<template>
  <div></div>
</template>

<script>
import {mapGetters, mapState} from 'vuex'
import {getStepInfo} from '@/utils'

export default {
  name: 'SessionJump',
  watch: {
    $route: function(to, from) {
      this.init()
    }
  },
  computed: {
    ...mapState(['stepStack']),
    ...mapGetters(['isMainMenu'])
  },
  methods: {
    init: function() {
      let step = ''

      if ('step' in this.$route.params) {
        step = this.$route.params.step
      }

      if (step && step.length) {
        let params = {step: step};
        [
          'order_number',
          'product_id',
          'campaign_product_id',
          'variant_id',
          'offer_intent'
        ].forEach(key => {
          if (key in this.$route.query) {
            params[key] = this.$route.query[key]
          }
        })

        this.$store.commit('busy')
        this.$store.dispatch('jump', params)
          .then(session => {
            if (this.isMainMenu) {
              this.$store.commit('clear_step_stack')
              this.$router.replace({name: 'session'})
            } else {
              const stepInfo = getStepInfo(session)
              this.$store.commit('push_to_step_stack', stepInfo)
              setTimeout(() => {
                this.$router.replace({name: 'session', params: {step: stepInfo.slug}})
              }, 200)
            }
          })
          .catch(err => {
            console.log(err)

            if (err.response && err.response.status === 400) {
              this.$router.replace({name: 'session'}) // invalid step to jump to - fail silently and stay where we are
            } else if (err.response && err.response.status === 422) {
              // stale session, start a new one at the jump step
              this.$router.replace({name: 'session-start-jump', params: {step: step}})
            } else if (err.response && [301, 302].indexOf(err.response.status) > -1) {
              if ('slug' in err.response.data) {
                this.$router.replace({name: 'session-jump', params: {step: err.response.data.slug}})
              } else {
                this.$store.commit('critical_error', err)
              }
            } else {
              this.$store.commit('critical_error', err)
            }
          })
      } else {
        console.log('Missing step to jump to')
        this.$router.replace({name: 'session'}) // ignore the jump and stay where we are in the session
      }
    }
  },
  created() {
    this.init()
  }
}
</script>

<style scoped>

</style>
